(async () => {
    const { Core } = await importModule('Core');
    const PREFIX_BUY_WITH = 'buy_with_';
    const LINE_ITEM_PROPS_REGEXP = /(?<=\[).+?(?=\])/;

    customElements.define('product-form', class extends Core {

        elements = {
            formTargeter: '[data-product-form-targeter]',
            toCartButton: 'product-to-cart'
        }

        render() {
            if (!this.$formTargeter) return;
            this.$form = this.$formTargeter.form;
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
        }

        _submitHandler(e) {
            e.preventDefault();
            const toCartButton = this.querySelector('product-to-cart');
            if (toCartButton && typeof toCartButton.addToCart === 'function') {
                toCartButton.addToCart(this.cartItems, this.mainVariantId);
            }
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName.includes(PREFIX_BUY_WITH) ||
                inputName === 'id' ||
                inputName.includes('items');
        }

        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem({ isMain = false, id, qty = 1 }) {
            if (isMain) this.mainVariantId = id
            const sellingPlanId = this.sellingPlanId || '';
            return {
                id: id,
                quantity: this._getItemQty(isMain, qty),
                selling_plan: isMain ? sellingPlanId : '',
                properties: this._getProperties(isMain)
            }
        }

        _getItemQty(isMain, fallback = 1) {
            return isMain ? this.qty : Number(fallback);
        }
        _getProperties(isMain) {
            return isMain ? this.properties : {};
        }

        get cartItems() {
            const filteredData = Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))

            const idMap = filteredData.reduce((acc, [inputName, value]) => {
                if (inputName === 'id') {
                    return {
                        ...acc,
                        [inputName]: value
                    }
                }

                if (!inputName.endsWith('id')) return acc

                const newInputName =  inputName.replace(/id$/, '');
                return {
                    ...acc,
                    [`${newInputName}id`]: value,
                    [`${newInputName}quantity`]: value
                }
            }, {})

            return Object.values(filteredData.reduce((acc, [inputName, value]) => {
                const id = idMap[inputName] || value;
                const property = inputName.split(']').slice(1).join(']');

                return {
                    ...acc,
                    [id]: {
                        ...acc[id],
                        [property || 'id']: value,
                        ...(inputName === 'id' ? { isMain: true } : {})
                    }
                }
            }, {}))
            .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
        get properties() {
            return Array.from(this.formData.entries()).reduce((acc, [key, val]) => {
                if (key.startsWith('properties[') && key.endsWith(']') && val) {
                    const propKey = key.match(LINE_ITEM_PROPS_REGEXP)[0];
                    acc[propKey] = val;
                }
                return acc;
            }, {});
        }
    })
})();
